import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import TypographyOverflow from '@liquidweb-dev/undercurrent/TypographyOverflow';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

import PaymentMethodIcon from 'components/PaymentMethodIcon';

export interface PaymentMethodDetailsProps extends BoxProps {
	issuer?: string;
	/** the row label the Billing list gives this method, e.g. `•••• •••• •••• 1117` */
	label: string;
	paymentMethod: string | undefined;
	/** the quieter label after `label`, the bank name on a bank method */
	secondaryLabel?: string;
}

/** How the dialog shows a payment method, whether it is being confirmed or chosen */
const PaymentMethodDetails = ({
	issuer,
	label,
	paymentMethod,
	secondaryLabel,
	sx,
	...rest
}: PaymentMethodDetailsProps) => (
	<Box
		sx={combineSx(
			{ alignItems: 'center', display: 'flex', gap: 100, minWidth: 0 },
			sx,
		)}
		{...rest}
	>
		<PaymentMethodIcon
			paymentMethod={paymentMethod}
			issuer={issuer}
			sx={({ size }) => ({
				height: size.sm,
				width: size.sm,
				flexShrink: 0,
			})}
		/>
		<Typography
			variant="title-xs"
			sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}
		>
			{label}
		</Typography>
		{/* free text the customer sets, so it truncates rather than wraps */}
		{secondaryLabel && (
			<TypographyOverflow
				sx={({ vars }) => ({ color: vars.palette.uc.text.medium })}
				variant="label-lg"
			>
				{secondaryLabel}
			</TypographyOverflow>
		)}
	</Box>
);

export default PaymentMethodDetails;
